import React, { Component } from 'react';
import { Modal, Grid, Form, TextArea, Button } from 'semantic-ui-react';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

class RejectMealModal extends Component {
  constructor() {
    super();

    this.state = {
      text: null
    };
  }

  changeText = (e, data) => {
    if (data.value.length > 100) {
      toastr('top-right', 'warning', '100자 이하로 입력해주세요.');
      return;
    } else {
      this.setState({ text: data.value });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { text } = this.state;
    if (!cm.valueCheck(text) && text.length <= 100) {
      const { rejectMeal } = this.props.modalFn;
      rejectMeal(text);
    } else {
      toastr('top-right', 'warning', '100자 이하로 입력해주세요.');
      return;
    }
  };

  render() {
    const { open, closeModal, count, members } = this.props.modalFn,
      rejectedMembers = members.join(', ');

    return (
      <Modal className="reject-modal modal-medium" dimmer={open} open={open} onClose={closeModal}>
        <Modal.Header>반려</Modal.Header>

        <Modal.Content>
          <div className="row">
            <div className="left">
              <span>반려 인원</span>
            </div>
            <div className="right">
              {count}명 <br />
              {rejectedMembers}
              <br />
              <br />
            </div>
          </div>
          <div className="row">
            <div className="left">
              <span>반려 사유</span>
            </div>
            <div className="right">
              <Form>
                <TextArea
                  placeholder="100자 이하로 입력해주세요."
                  maxLength={100}
                  autoFocus
                  onChange={this.changeText}
                />
              </Form>
            </div>
          </div>
          {/* <Grid columns='equal'>
            <Grid.Row>
              <Grid.Column width={3}>반려인원</Grid.Column>
              <Grid.Column>{count}명 / {rejectedMembers}</Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={3}>반려사유</Grid.Column>
              <Grid.Column>
                <TextArea
                  placeholder='100자 이하로 입력하세요.'
                  onChange={this.changeText}
                  cols={50}
                  rows={4}
                  autoFocus
                  maxLength={100}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid> */}
        </Modal.Content>

        <Modal.Actions>
          <Button inverted color="grey" onClick={closeModal} content="취소" />
          <Button positive content="확인" onClick={this.handleSubmit} />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default RejectMealModal;
